import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { StateManager } from './shared/state-manager.class';
import { BaseUser } from './user/base-user.model';

@Injectable({
    providedIn: 'root'
})

export class RoutesGuard implements CanActivate {

    private _router: Router = inject(Router);
    private _stateManager: StateManager = inject(StateManager);
    
    private authenticatedUserRoutes = [
        "/home",
        "/unknown",
        "/pending-verification",
        "/error"
    ]

    private authorizedRoutes = {
        "/view-employees": "employee-viewer",
        "/add-employee": "employee-editor",
        "/update-employee": "employee-editor",
        "/view-dealers": "dealer-viewer",
        "/add-dealer": "dealer-editor",
        "/update-dealer": "dealer-editor",
        "/view-dealer-reps": "dealer-rep-viewer",
        "/add-dealer-rep": "dealer-rep-editor",
        "/update-dealer-rep": "dealer-rep-editor",
        "/view-customers": "customer-viewer",
        "/add-customer": "customer-editor",
        "/update-customer": "customer-editor",
        "/view-drones": "drone-viewer",
        "/add-drone": "drone-editor",
        "/update-drone": "drone-editor",
        "/transfer-drone": "drone-transfer",
        "/view-firmware": "manufacturing-info",
        // The "/view-pdf" entry is a working Use Case for validating
        // authorization on a route where part of the route is dynamic
        // yet within a finite set of known values. See "view-pdf"
        // route definition in app.routes.ts
        "/view-pdf": {
            "/manufacturing-doc": "manufacturing-info",
            "/user-manual": "user-software-and-manuals"
        },
        "/mission-planner": "user-software-and-manuals",
        "/upload-log-files": "log-uploader",
        "/view-log-files": "log-viewer"
    }

    public canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot):
        Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

        let urlRoute = (this._router.getCurrentNavigation()?.extractedUrl)?.toString();
        const userAccount:BaseUser = this._stateManager.getUserAccount();

        if (urlRoute == undefined
        ||  userAccount == undefined
        ||  userAccount.email == undefined
        ||  userAccount.email == "") {
            this._router.navigate(["/login"]);
            return false;
        }

        // Drop querystring if present.
        const endPos = urlRoute.indexOf("?")

        if (endPos > 0) {
            urlRoute = urlRoute.substring(0, endPos);
        }

        let isUserAuthorizedToRoute = false

        if (this.authenticatedUserRoutes.includes(urlRoute)) {
            isUserAuthorizedToRoute = true;    
        } else {
            const requiredRole = this.getRequiredRole(urlRoute);
            isUserAuthorizedToRoute = userAccount.user_roles.includes(requiredRole);
        }

        if (!isUserAuthorizedToRoute) {
            console.error(`${userAccount.email} (${this._stateManager.getUserType()}) not authorized to route ${urlRoute}`)
        }

        return isUserAuthorizedToRoute;
    }

    private getRequiredRole(route: string): string {
        let requiredRole = "";
        const pathElements = route.split('/').filter(Boolean);
        let currentRoutes:any = this.authorizedRoutes;

        for (let element of pathElements) {
            element = `/${element}`;
            if (typeof currentRoutes[element] === 'string') {
                requiredRole = currentRoutes[element];
                break;
            } else if (typeof currentRoutes[element] === 'object') {
                currentRoutes = currentRoutes[element];
            } else {
                console.error(`Unexpected type for element '${element}' of route '${route}: ${typeof currentRoutes[element]}`);
                break;
            }
        }
    
        return requiredRole;
    }
}